import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-accommodation-chat-info-dialog',
  templateUrl: './accommodation-chat-info-dialog.component.html',
  styleUrls: ['./accommodation-chat-info-dialog.component.css'],
})
export class AccommodationChatInfoDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AccommodationChatInfoDialogComponent>
  ) {}

  closeDialog(): void {
    this.dialogRef.close()
  }
}
